import {
  AddTwoTone,
  DeleteTwoTone,
  PersonAddAlt1TwoTone,
  PlayArrowTwoTone,
} from "@mui/icons-material";
import {
  Card,
  CardContent,
  CardHeader,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import {
  NertzGames,
  NertzGamesApi,
  deleteNertzGame,
  joinNertzGame,
} from "../../api/NertzApi";
import { Me, MeApi } from "../../api/MeApi";
import { useState } from "react";
import NertzEditor from "./NertzEditor";

function NertzGrid() {
  const games = useRecoilValue(NertzGames),
    me = useRecoilValue(Me),
    [add, setAdd] = useState(null),
    nav = useNavigate();

  return (
    <Card id="nertz-grid" raised>
      <MeApi />
      <NertzGamesApi />
      <CardHeader
        action={
          <IconButton
            color="primary"
            title="Add Game"
            onClick={(e) => setAdd(e.currentTarget)}
          >
            <AddTwoTone />
          </IconButton>
        }
        title="Nertz"
      />
      <CardContent>
        <Table size="small" sx={{ width: 1 }}>
          <TableHead>
            <TableRow>
              <TableCell component="th" scope="row">
                Players
              </TableCell>
              <TableCell align="right">Play to</TableCell>
              <TableCell width={50} />
            </TableRow>
          </TableHead>
          <TableBody>
            {games &&
              games.map((g) => (
                <TableRow key={g.id} hover>
                  <TableCell component="th" scope="row">
                    {g.players
                      .map((p) => `${p.username} (${p.wins})`)
                      .join(", ")}
                  </TableCell>
                  <TableCell align="right">{g.playTo}</TableCell>
                  <TableCell width={50}>
                    <Stack direction="row">
                      <IconButton
                        color="primary"
                        disabled={!g.players.some((p) => p.id === me?.userId)}
                        onClick={() => {
                          nav(`/nertz/${g.id}`);
                        }}
                        title="Start Game"
                      >
                        <PlayArrowTwoTone />
                      </IconButton>
                      <IconButton
                        disabled={
                          g.isLocked ||
                          !!g.players.some((p) => p.id === me?.userId)
                        }
                        onClick={() => {
                          joinNertzGame(g.id);
                        }}
                        title="Join Game"
                      >
                        <PersonAddAlt1TwoTone />
                      </IconButton>
                      <IconButton
                        disabled={g.ownerId !== me?.userId}
                        title="Delete Game"
                        onClick={() => {
                          deleteNertzGame(g.id);
                        }}
                      >
                        <DeleteTwoTone />
                      </IconButton>
                    </Stack>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </CardContent>
      <NertzEditor anchorEl={add} open={!!add} onClose={() => setAdd(null)} />
    </Card>
  );
}

export default NertzGrid;
